export default __webpack_public_path__ + "static/media/05_DAIF_UseCase_02_end.9f165716.jpg";